/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Work_0_Metric_0_LabelInputs */

const en_svc_ai_app_rescue_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community members`)
};

const ar_svc_ai_app_rescue_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أعضاء المجتمع`)
};

const bn_svc_ai_app_rescue_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কমিউনিটি মেম্বার`)
};

const de_svc_ai_app_rescue_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-Mitglieder`)
};

const es_svc_ai_app_rescue_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembros de la comunidad`)
};

const fr_svc_ai_app_rescue_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membres de la communauté`)
};

const pt_svc_ai_app_rescue_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membros da comunidade`)
};

const zh_svc_ai_app_rescue_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社区成员`)
};

const tr_svc_ai_app_rescue_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topluluk üyeleri`)
};

const ru_svc_ai_app_rescue_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Участники сообщества`)
};

const pl_svc_ai_app_rescue_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Członkowie społeczności`)
};

/**
* | output |
* | --- |
* | "Community members" |
*
* @param {Svc_Ai_App_Rescue_Work_0_Metric_0_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_work_0_metric_0_label = /** @type {((inputs?: Svc_Ai_App_Rescue_Work_0_Metric_0_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Work_0_Metric_0_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_work_0_metric_0_label(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_work_0_metric_0_label(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_work_0_metric_0_label(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_work_0_metric_0_label(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_work_0_metric_0_label(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_work_0_metric_0_label(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_work_0_metric_0_label(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_work_0_metric_0_label(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_work_0_metric_0_label(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_work_0_metric_0_label(inputs)
	return en_svc_ai_app_rescue_work_0_metric_0_label(inputs)
});
export { svc_ai_app_rescue_work_0_metric_0_label as "svc_ai-app-rescue_work_0_metric_0_label" }